import { lazyLoad } from 'utils/loadable';

export const EditUnitWrapperLoadable = lazyLoad(
  () => import('./EditUnitWrapper'),
  module => module.EditUnitWrapper,
);
